import { ownedBy, type PendingAttempt } from '../content/outbox';
import { useOutbox } from './outbox-store';
import { useMe } from './use-me';

/** The signed-in person's attempts, whether or not Core has recorded them yet. */
export function useMyAttempts(): readonly PendingAttempt[] {
  const outbox = useOutbox();
  return ownedBy(outbox, useMe().data?.uuid);
}

/**
 * The signed-in person's attempts still to send; another account's are not theirs to see, and
 * one Core has recorded no longer waits.
 */
export function useMyOutbox(): readonly PendingAttempt[] {
  return useMyAttempts().filter((item) => item.sentAt === undefined);
}
